import { z } from 'zod';

const safeParamRegex = /^[A-Za-z0-9.+_\-äöåÄÖÅ ]+$/;

export const AnalyticsSchema = z
  .object({
    cmpid: z.string().regex(safeParamRegex, 'Invalid cmpid').max(150, 'cpmid too long').optional(),
    fbclid: z.string().regex(safeParamRegex, 'Invalid fbclid').max(200, 'fbclid too long').optional(),
    gclid: z.string().regex(safeParamRegex, 'Invalid gclid').max(100, 'gclid too long').optional(),
    icmp: z.string().regex(safeParamRegex, 'Invalid icmp').max(100, 'icmp too long').optional(),
    utm_medium: z.string().regex(safeParamRegex, 'Invalid utm_medium').max(20, 'utm_medium too long').optional(),
    utm_source: z.string().regex(safeParamRegex, 'Invalid utm_source').max(20, 'utm_source too long').optional(),
    utm_id: z.string().regex(safeParamRegex, 'Invalid utm_id').max(50, 'utm_id too long').optional(),
    utm_content: z.string().regex(safeParamRegex, 'Invalid utm_content').max(50, 'utm_content too long').optional(),
    utm_term: z.string().regex(safeParamRegex, 'Invalid utm_term').max(50, 'utm_term too long').optional(),
    utm_campaign: z.string().regex(safeParamRegex, 'Invalid utm_campaign').max(50, 'utm_campaign too long').optional(),
    media_type: z.string().regex(safeParamRegex, 'Invalid media_type').max(20, 'media_type too long').optional(),
    gad_source: z.string().regex(safeParamRegex, 'Invalid gad_source').max(20, 'gad_source too long').optional(),
  })
  .strict();
